import { render, staticRenderFns } from "./LessonsActivity.vue?vue&type=template&id=519a287e&scoped=true&"
import script from "./LessonsActivity.vue?vue&type=script&lang=js&"
export * from "./LessonsActivity.vue?vue&type=script&lang=js&"
import style0 from "./LessonsActivity.vue?vue&type=style&index=0&id=519a287e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a287e",
  null
  
)

export default component.exports